function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#F54C15",
  transform: "rotate(-180 11 11)"
}, React.createElement("circle", {
  cx: 10.5,
  cy: 10.5,
  r: 10.5,
  fill: "#160527"
}), React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "M7.4 9.682l3.1-3.313M13.682 9.682L10.5 6.369M10.5 6.37v9"
})));

const SvgComponent = props => React.createElement("svg", _extends({
  width: 23,
  height: 23,
  viewBox: "0 0 23 23"
}, props), _ref);

export default __webpack_public_path__ + "static/media/negative.1fa2bf86.svg";
export { SvgComponent as ReactComponent };